<template>
  <b-card
    class="h-100 mb-0"
    body-class="p-1"
  >
    <template v-if="!loading">
      <small class="text-muted"> <slot name="primary-text" /> </small>
      <h4
        :class="oneValueMode ? '' : textClass"
      >
        {{ currentValue | formatCurrency }}
      </h4>
      <template v-if="!oneValueMode">
        <small class="text-dark d-block">
          <span v-if="currentValue - previousValue < 0">
            <GjIcon
              :key="basicGuid()"
              name="ArrowDownAlt"
            />
          </span>
          <span v-else-if="currentValue - previousValue > 0">
            <GjIcon
              :key="basicGuid()"
              name="ArrowUpAlt"
            />
          </span>
          <span v-else>
            <GjIcon
              :key="basicGuid()"
              name="Minus"
            />
          </span>
          <span
            class="font-weight-bold"
            :class="textClass"
          >
            {{ previousValue | formatCurrency }} ({{ percentage }} %)
          </span>
        </small>
        <small class="text-muted"> <slot name="secondary-text" /></small>
      </template>
    </template>
    <template v-else>
      <b-skeleton
        width="30%"
        class="mt-50"
      />
      <b-skeleton
        class="mt-n50"
        width="50%"
        height="20%"
      />
      <b-skeleton
        width="40%"
      />
    </template>
  </b-card>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  props: {
    currentValue: {
      type: Number,
      default: 0,
    },
    previousValue: {
      type: Number,
      default: 0,
    },
    oneValueMode: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    textClass() {
      const diff = this.currentValue - this.previousValue
      if (diff < 0) return 'text-danger'
      if (diff > 0) return 'text-success'
      return ''
    },
    percentage() {
      if (this.previousValue === 0) return 0
      return (((this.currentValue - this.previousValue) / this.previousValue) * 100).toFixed(2)
    },
  },
  methods: {
    basicGuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0; var
          // eslint-disable-next-line no-bitwise
          v = c === 'x' ? r : ((r & 0x3) | 0x8)
        return v.toString(16)
      })
    },
  },
}
</script>
